import service from "@/api/request";
/**
 * @description 获取所有启用状态的训练营
 * @returns 返回训练营列表
 */
export const getEnabledCampList = () => service.getByQuery(`/courseAdmin/camp/enabledCampList`);
/**
 * @description 获取当前训练营所有启用状态的营期
 * @returns 返回营期列表
 */
export const getEnabledTermList = (id) => service.getByQuery(`/courseAdmin/course/enabledTermList?campId=${id}`);
/**
 * @description 获取所有启用状态的专栏
 * @returns 返回专栏列表
 */
export const getEnabledColumnList = () => service.getByQuery(`/courseAdmin/course/enabledColumnList`);
/**
 * @description 获取学员列表
 * @param data
 * @return 返回学员列表
 */
export const getUserList = (data = {}) => service.postByJson(`/courseAdmin/user/selfResearch/page`, data);
/**
 * @description 单个添加学员
 * @param data
 * @return void
 */
export const saveUser = (data = {}) => service.postByJson(`/courseAdmin/user/selfResearch/saveUserCourse`, data);
/**
 * @description 获取导入列表
 * @param data
 * @return void
 */
export const getExportList = (id) => service.getByQuery(`/courseAdmin/user/selfResearch/listByImport?courseId=${id}`);
/**
 * @description 移除学员
 * @param data
 * @return void
 */
export const removeStudent = (data = {}) => service.postByJson(`/courseAdmin/user/selfResearch/removeUserCourse`, data);
/**
* @description 调整营期
* @param data
* @return void
*/
export const changeStudentCourse = (data = {}) => service.postByJson(`/courseAdmin/user/selfResearch/changeUserCourse`, data);
